import React, { Fragment,useEffect }  from 'react';
import Breadcrumb from './components/breadcrumb';
import List from './components/list';
import useGlobal from './store';

export default () => {
  const [globalState, globalActions] = useGlobal();
  useEffect(() => {
    const { pageInfo } = globalActions;
    pageInfo();
  }, [globalActions]);
  return (
    <Fragment>
      <Breadcrumb />
      <List
        pageDataInfo = {globalState.pageDataInfo}
        changePageInfo= {globalActions.pageInfo}
       />
    </Fragment>
  )
}
